var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"wrapper",staticClass:"messages_wrapper",style:(_vm.styleWrapper)},[(_vm.popups.winFreeBet)?_c('WinFreeBetMessage'):_vm._e(),(_vm.popups.freeBetsStarted)?_c('DistributionFreeBets'):_vm._e(),(_vm.popups.freeBetsFinished)?_c('DistributionFinishedFreeBets'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }